import React, { Component } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBAnimation,
  MDBIcon,
  MDBTooltip,
} from "mdbreact";
import { firebase } from "../../../firebase/config";
import "../index.css";
import "./index.css";
import { NavLink } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import {
  RiHomeSmile2Line,
  RiApps2Line,
  RiStore2Line,
  RiMoneyDollarBoxLine,
  RiSettings4Line,
  RiLogoutBoxLine,
  RiKey2Line,
  RiKeyFill,
  RiKey2Fill,
  RiTestTubeFill,
} from "react-icons/ri";
import { HiCash } from "react-icons/hi";
import { BiSearch, BiCart } from "react-icons/bi";
import { IoRadioSharp } from "react-icons/io5";
import { FaQuestion, FaTeethOpen } from "react-icons/fa";
class MenuDesktop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: "Settings",
      isNavbar: true,
    };
  }

  render() {
    return (
      <>
        <MDBCol
          className="d-flex justify-content-between"
          style={{
            backgroundColor: "transparent",
            height: 86,
          }}
          size="12"
        >
          <NavLink to="/" exact onClick={() => window.scrollTo(0, 0)}>
            <p
              style={{
                fontFamily: "Grifter",
                color: "white",
                fontSize: 23,
                fontWeight: "900",
                marginTop: 32,
                display: "inline-block",
                marginLeft: 85,
              }}
            >
              <img
                style={{ height: 30, marginTop: -5.6 }}
                src={require("./Logo.png")}
              />{" "}
              YouDub
            </p>
          </NavLink>

          <div style={{ display: "inline-block" }}>
            <NavLink to="/about" exact onClick={() => window.scrollTo(0, 0)}>
              {" "}
              <p
                style={{
                  cursor: "pointer",
                  fontFamily: "PlusJSMedium",
                  fontSize: 14,
                  marginTop: 38,
                  display: "inline-block",
                  marginLeft: 19,
                  marginRight: 19,
                  color: "white",
                }}
              >
                Why YouDub?
              </p>
            </NavLink>
            <NavLink to="/pricing" exact onClick={() => window.scrollTo(0, 0)}>
              {" "}
              <p
                style={{
                  cursor: "pointer",
                  fontFamily: "PlusJSMedium",
                  fontSize: 14,
                  marginTop: 38,
                  display: "inline-block",
                  marginLeft: 23,
                  marginRight: 23,
                  color: "white",
                }}
              >
                Pricing
              </p>
            </NavLink>
            <NavLink to="/careers" exact onClick={() => window.scrollTo(0, 0)}>
              <p
                style={{
                  color: "white",
                  cursor: "pointer",
                  fontFamily: "PlusJSMedium",
                  fontSize: 14,
                  marginTop: 38,
                  display: "inline-block",
                  marginLeft: 23,
                  marginRight: 23,
                }}
              >
                We're hiring
              </p>
            </NavLink>
            <a
              href="https://clonedub.com"
              target="_blank"
              exact
              onClick={() => window.scrollTo(0, 0)}
            >
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  fontSize: 14,
                  marginTop: 38,
                  display: "inline-block",
                  marginLeft: 23,
                  marginRight: 23,
                  cursor: "pointer",
                  color: "white",
                }}
              >
                Playground{" "}
              </p>
            </a>
            <a href="https://app.youdub.me" target="_blank">
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  fontSize: 14,
                  marginTop: 36,
                  display: "inline-block",
                  marginLeft: 23,
                  marginRight: 23,
                  color: "white",
                }}
              >
                Log in
              </p>
            </a>
          </div>
          <a
            href="https://app.youdub.me"
            target="_blank"
            to="sign-up"
            exact
            style={{
              height: 47,
              width: 120,
              backgroundColor: "#FF0000",
              borderRadius: 200,
              marginTop: 22,
            }}
            className={`menuButton ${
              this.props.color === "dark" ? "menuButtonDark" : "menuButtonLight"
            }`}
          >
            <p style={{ marginTop: 12 }} className="menuButtonText">
              Try it out{" "}
            </p>
          </a>
        </MDBCol>
      </>
    );
  }
}

export default MenuDesktop;
